module.exports = __webpack_public_path__ + "static/basil-2-e686cd136e918a94cb8faf093d5bb1af.jpg";